import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Play, ArrowRight, X } from "lucide-react";
import { fetchMedia } from "../lib/api";

const CoulissesSection = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    fetchMedia({ featured: true })
      .then((all) => setItems(all.slice(0, 4)))
      .catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="coulisses" data-testid="coulisses-section" className="py-28 md:py-36 bg-[#080808] border-y border-white/5">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div>
            <p className="label-caps text-[color:var(--gold)] mb-6">Dans les coulisses</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight">
              La <em className="italic text-[color:var(--gold-soft)]">Maison</em>, en toute transparence.
            </h2>
          </div>
          <Link to="/galerie" className="label-caps text-[color:var(--gold)] border-b border-[color:var(--gold)] pb-1 flex items-center gap-3 hover:gap-5 transition-all self-start">
            Toute la galerie <ArrowRight size={14} />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {items.map((m, i) => (
            <button
              key={m.id}
              onClick={() => setOpen(m)}
              className="group relative aspect-[3/4] bg-black overflow-hidden reveal"
              style={{ animationDelay: `${i * 120}ms` }}
              data-testid={`coulisses-item-${i}`}
            >
              {m.media_type === "video" ? (
                <video src={m.media_url} className="w-full h-full object-cover product-image" muted playsInline preload="metadata" />
              ) : (
                <img src={m.media_url} alt={m.title} className="w-full h-full object-cover product-image" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              {m.media_type === "video" && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-[color:var(--gold)]/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <Play size={16} className="text-black ml-0.5" fill="currentColor" />
                  </div>
                </div>
              )}
              <div className="absolute bottom-3 left-3 right-3 text-left">
                <p className="font-serif text-white text-sm leading-tight">{m.title}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {open && (
        <div className="fixed inset-0 z-[80] bg-black/95 flex items-center justify-center p-4" onClick={() => setOpen(null)}>
          <button onClick={() => setOpen(null)} className="absolute top-6 right-6 text-white/70 hover:text-white"><X size={24} /></button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            {open.media_type === "video" ? (
              <video src={open.media_url} controls autoPlay className="w-full max-h-[80vh]" />
            ) : (
              <img src={open.media_url} alt={open.title} className="w-full max-h-[80vh] object-contain" />
            )}
            <p className="text-center font-serif text-2xl text-white mt-6">{open.title}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default CoulissesSection;
